import { Pipe } from '@angular/core';
import { LabelOrAlternativePipe } from './label-or-alternative.pipe';
import { MaterialChoices } from '../../../../model/product/board/board';

@Pipe({
  name: 'materialOrAlternative'
})
export class MaterialOrAlternativePipe extends LabelOrAlternativePipe {
  constructor() {
    super(MaterialChoices.UNSPECIFIED.ordinal);
  }
}
